import { AdditionalServices } from "widgets/additionalServices";

export const HoneyExchangePage = () => <AdditionalServices serviceName='Медовая биржа'/>
